export default {
    data() {
        return {
            templateData: {
                page: 1,
                query: null,
                pageLimit: 24,
            },
        };
    },
    methods: {
        handlePageChange(page) {
            this.templateData.page = page;
            this.getTemplates();
        },
        onSearch({ value }) {
            this.templateData.query = value;
            this.templateData.page = 1;
            this.getTemplates();
        },
        onResetSearch() {
            this.templateData.query = null;
            this.getTemplates();
        },
        getTemplates() {
            this.$store.dispatch('templates/PAGINATE', {
                searchQuery: {
                    query: this.templateData.query,
                },
                pageLimit: this.templateData.pageLimit,
                page: this.templateData.page,
            });
        },
    },
};
